<template>
<div class="progress-bar">
    <h3>Progress Bar</h3>
    <div :class="$prefixClass.row">
        <a-form-model ref="formProgressBar" :model="formProgressBar" v-bind="layout">
            <a-form-model-item class="m-b-24" label="Loading color">
                <VueColorpicker v-model="formProgressBar.loadingColor"/>
            </a-form-model-item>
            <a-form-model-item class="m-b-24" label="Bar color">
                <VueColorpicker v-model="formProgressBar.barColor"/>
            </a-form-model-item>
            <a-form-model-item class="m-b-24" label="Position">
                <a-select :prefixCls="$prefixClass.select" v-model="formProgressBar.position">
                    <i class="fas fa-chevron-down" slot="suffixIcon"></i>
                    <a-select-option v-for="(item, index) in listPosition" :key="index" :value="item.value">{{item.text}}</a-select-option>
                </a-select>
            </a-form-model-item>   
            <a-form-model-item class="m-b-24" label="Size" :class="formProgressBar.position !== 'middle' ? 'field-disabled' : ''">
                <a-select :prefixCls="$prefixClass.select" v-model="formProgressBar.size" :disabled="formProgressBar.position !== 'middle'">
                    <i class="fas fa-chevron-down" slot="suffixIcon"></i>
                    <a-select-option v-for="(item, index) in listSize" :key="index" :value="item.value">{{item.text}}</a-select-option>
                </a-select>
            </a-form-model-item>
            <div :class="formProgressBar.position != 'middle' ? 'field-disabled' : ''">
                <a-form-model-item :label-col="{span: 24}" :wrapper-col="{span: 24}">
                    <a-checkbox v-model="formProgressBar.isUseStripeColor">
                    Use stripe pattern
                    </a-checkbox>
                </a-form-model-item>
                <a-form-model-item label="Stripe color" v-if="formProgressBar.isUseStripeColor">
                    <VueColorpicker v-model="formProgressBar.stripeColor"/>
                </a-form-model-item>
            </div>
        </a-form-model>
    </div>
</div>
</template>
<script>
export default {
    name: "ProgressBar",
    props: {
        value: {
            type: Object,
            required: true,
        }
    },
    data() {
        return {
            listSize: [
                {
                    text: 'Very Small',
                    value: 'very_small'
                },
                {
                    text: 'Small',
                    value: 'small'
                },
                {
                    text: 'Medium',
                    value: 'medium'
                },
                {
                    text: 'Large',
                    value: 'large'
                },
                {
                    text: 'Very Large',
                    value: 'very_large'
                }
            ],
            listPosition: [
                {
                    text: 'Top',
                    value: 'top'
                },
                {
                    text: 'Middle',
                    value: 'middle'
                },
                {
                    text: 'Bottom',
                    value: 'bottom'
                }
            ],
            layout: {
                labelCol: {
                    span: 12
                },
                wrapperCol: {
                    span: 12
                },
            },
        };
    },
    computed: {
        formProgressBar: {
            get() {
                return this.value;
            },
            set(value) {
                this.$emit("input", this.value);
            }
        }
    },
    watch: {
    },
    created() {},
    mounted() {
    },
    methods: {
        // changePosition(value) {
        //     this.formProgressBar.isUseStripeColor = value === 'middle'
        // }
    },
};
</script>

<style lang="scss">
    .progress-bar {
    }
</style>
